import {
  encartMiseEnAvantMock,
  heroComponentMock,
  sliderVideoMock,
  texteSeoVisuelBasMock,
  titreTexteCtaImageMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  heroComponentMock,
  titreTexteCtaImageMock('white', true),
  encartMiseEnAvantMock,
  sliderVideoMock(true),
  texteSeoVisuelBasMock,
];

export const estimateurBudgetMock: SlugPage = {
  ...pageBase({
    title: 'Estimateur de bugdet - LP',
    type: 'estimateur-budget',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
